import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepThreeComponent } from './steps/step-three/step-three.component'
import { SignupRoutingModule } from './signup.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { XeroSignUpComponent } from './steps/xero-sign-up/xero-sign-up.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SignupWizzardComponent } from './wizzard/signup-wizzard/signup-wizzard.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { ModalModule } from "ngx-bootstrap/modal";
import { StepConfirmEmailComponent } from './steps/step-confirm-email/step-confirm-email.component';
import { StepVerifyEmailComponent } from './steps/step-verify-email/step-verify-email.component';
import { StepCreateAccountComponent } from './steps/step-create-account/step-create-account.component';
import { StepCaptureMethodsComponent } from './steps/step-capture-methods/step-capture-methods.component';
import { CaptureEmailSetupComponent } from './steps/capture-email-setup/capture-email-setup.component';
import { CaptureMobileSetupComponent } from './steps/capture-mobile-setup/capture-mobile-setup.component';
import { CommonSharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    StepThreeComponent,
    XeroSignUpComponent,
    SignupWizzardComponent,
    StepConfirmEmailComponent,
    StepVerifyEmailComponent,
    StepCreateAccountComponent,
    StepCaptureMethodsComponent,
    CaptureEmailSetupComponent,
    CaptureMobileSetupComponent
  ],
  imports: [
    CommonModule, SignupRoutingModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    NgSelectModule,
    FormsModule,
    MatTooltipModule,
    MatRadioModule,
    ModalModule.forRoot(),
    CommonSharedModule
  ],
  exports: [
    StepCreateAccountComponent,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SignUpModule { }
